
export enum DisputeProValidationStatusCd {
	NOT_VALIDATED = 'NotValidated',
	VALIDATED = 'Validated'}

